<!-- eslint-disable vue/multi-word-component-names -->
<!-- Markup generated verbatim from the-dream-international.html (page "policy"). -->
<template>
<div class="page" data-page="policy">
  <section class="phero">
    <div class="wrap">
      <span class="eyebrow"><span class="dot"></span>Policy</span>
      <h1>Nondiscriminatory policy notice</h1>
    </div>
  </section>
  <section class="block">
    <div class="wrap prose">
      <p>The Dream is committed to providing an inclusive and welcoming environment for all students. We do not discriminate on the basis of race, color, national or ethnic origin, or any other characteristic protected under applicable law in the administration of our educational policies, admissions policies, and other programs.</p>
      <p>For more information about our nondiscriminatory policy, please contact us at admin@thedreaminc.org.</p>
    </div>
  </section>
</div>
</template>

<script>
import { SITE } from '@/data/site';
import { openLogin } from '@/composables/useLogin';
import { copyText } from '@/composables/useToast';

export default {
  name: 'NonDiscriminatoryPolicy',
  methods: {
    openLogin,
    openPaypal() {
      window.open(SITE.paypalDonateUrl, '_blank', 'noopener');
    },
    copy(key) {
      copyText(SITE.copyValues[key], this.$el.querySelector('#' + key));
    },
  },
};
</script>
